module.exports = __webpack_public_path__ + "static/media/car.bc5b6a60.png";